import React from 'react'
import { Typography } from '@mui/material'
import {
  OnboardingMainHeading,
  OnboardingSubHeading,
  OnboardingTitleContainer,
} from './styled/OnboardTitleTypography.styled'

interface Props {
  title: string
  subTitle: string
  isEditPreference?: boolean
  alignItems?: 'center' | 'right' | 'left'
  points?: number // Optional points to display
}

const OnboardTitleTypography: React.FC<Props> = ({
  title,
  subTitle,
  isEditPreference = false,
  alignItems = 'center',
  points,
}: Props): JSX.Element => {
  return (
    <OnboardingTitleContainer
      textAlign={alignItems}
      data-testid="onboarding-title-container"
    >
      <OnboardingMainHeading>{title}</OnboardingMainHeading>
      {!isEditPreference && (
        <>
          <OnboardingSubHeading>{subTitle}</OnboardingSubHeading>
          {points !== undefined && (
            <Typography
              variant="subtitle2"
              color="text.secondary"
              sx={{ mt: 0.5 }}
            >
              Complete this step to earn {points} points
            </Typography>
          )}
        </>
      )}
    </OnboardingTitleContainer>
  )
}

export default OnboardTitleTypography
